<template>
  <div>
    <Head :title="`Issuance - ${form.item_uid} `" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-orange-600 hover:text-orange-500" href="/issuances">Issuances {{ form.errors }}</Link>
        <span class="text-orange-600 font-medium">/</span>
        {{ form.item_uid }} 
      </h1>
    </div>

    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.receipt" type="hidden" />
          <text-input v-model="form.card" type="hidden" />
          <text-input v-model="form.id" type="hidden" />
          <text-input v-model="form.item_uid" :error="form.errors.receipt" class="pb-8 pr-6 w-full lg:w-1/2" label="UID" />
          <text-input v-model="form.quantity" :error="form.errors.quantity" class="pb-8 pr-6 w-full lg:w-1/2" label="Quantity" />
          <select-input
            v-model="form.location"
            :error="form.errors.location"
            class="pb-2 pr-6 w-full lg:w-1/2"
          >
            <option :value="null">
              Select the location
            </option>
            <option
              v-for="location in locations"
              :key="location"
              :value="location.id"
            >
              {{ location.name }}
            </option>
          </select-input>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange ml-auto" type="submit">Issue Item</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
// import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
//import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    // FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    //TrashedMessage,
  },
  layout: Layout,
  props: {
    item: Object,
    receipt: Object,
    locations: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        receipt: this.receipt ? this.receipt.id : null,
        card: this.item.card,
        id: this.item.id,
        item_uid: this.item.item_uid,
        quantity: this.item.quantity,
        location: this.item.location,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(`/jobcards/${this.item.id}/items`)
    },
    /*destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia.delete(`/jobcards/${this.user.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put(`/jobcards/${this.user.id}/restore`)
      }
    },*/
  },
}
</script>
